// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__31U88","load6":"loader_load6__E-xHB","round":"loader_round__odvTS"};